import { CardContent, CardHeader, FormControl, FormControlLabel, FormHelperText, Grid2, IconButton, Stack, Switch } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { ArrowBack } from "@mui/icons-material"
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSnackbar } from "../../../context/popup";
import { useLoading } from "../../../components/Loading";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialSelect from "../../../components/MasterSelect";
import { useWorkflowStepDependencyFormHandling } from "./components/WorkflowStepDependencyStateHandle.js";
import MaterialInput from "../../../components/MaterialInput/index.js";
import MaterialButton from "../../../components/MaterialButton/index.js";
import MaterialBox from "../../../components/MaterialBox/index.js";
import { postData, putData } from "../../../services/index.js";


const WorkflowStepDependencyForm = () => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const pageType = searchParams.get("pageType");
    const pageMode = pageType === "view" ? "view" : pageType === "edit" ? "edit" : "add";
     const workflowDependencyId = searchParams.get("id");

    //post and put api function
    const handleSubmitWorkflowStepDependency = async () => {
        const payload = {
            stepId: formData?.stepId?.value,
            dependsOnStepId: formData?.dependsOnStepId?.value,
            dependencyTypeId: formData?.dependencyTypeId?.value,
            conditionExpression: formData?.conditionExpression,
            description: formData?.description,
            isActive: formData?.isActive,
        };
        //Update
        if(workflowDependencyId){
            try {
                setCircleLoading(true);
                const response = await putData(`/reference/orchestration/work-flow-step-dependencies/${workflowDependencyId}`, payload);
                
                const responseMessage = response?.message;
                if(response?.success){
                //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/operation/workflow-step-dependency');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error")
                }
            } catch (error) {
                console.error('Error updating data:', error);
                showSnackbar(error?.response?.data?.message || "Error Updating Body Type","error");
            }finally{
                setCircleLoading(false);
            }
        }
        else{      
        //Submit
            try {
                setCircleLoading(true);
                const response = await postData('/reference/orchestration/work-flow-step-dependencies', payload);                
                const responseMessage = response?.message;
                if(response?.success){
                    //success message
                    showSnackbar(responseMessage, "success");
                    navigate('/operation/workflow-step-dependency');          
                }
                else{
                    //error message
                    showSnackbar(responseMessage, "error");
                }
            } catch (error) {
                //catch error message
                console.error('Error posting data:', error);
                showSnackbar(error?.response?.data?.message || 'Network Error',"error")
            }finally{
                setCircleLoading(false);
            }
        }
    };
    
    const { formData, setFormData, handleChange, checkAllFields } = useWorkflowStepDependencyFormHandling(); 

  return (
    <DashboardLayout>
        <CardHeader
            title={
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    spacing={2}
                >
                    <Stack direction="row" alignItems="center" spacing={1}>
                        <IconButton
                            onClick={() => navigate("/operation/workflow-step-dependency")}
                        >
                            <ArrowBack />
                        </IconButton>
                        <Stack direction="column" spacing={0}>
                            <MaterialTypography variant="h5" fontWeight="medium">
                                Workflow Step Dependency Details
                            </MaterialTypography>
                            <MaterialTypography variant="caption" color="text">
                                Enter New Workflow Step Dependency Details.
                            </MaterialTypography>
                        </Stack>
                    </Stack>
                </Stack>
            }
        />
        <CardContent>
            <Grid2 container spacing={1}>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Step*
                    </MaterialTypography>
                    <MaterialSelect
                    name="stepId"
                    value={formData.stepId}
                    onChange={handleChange}
                    // options={workflowOptions}
                    success={formData.stepIdStatus === "success"}
                    error={formData.stepIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Depends On Step*
                    </MaterialTypography>
                    <MaterialSelect
                    name="dependsOnStepId"
                    value={formData.dependsOnStepId}
                    onChange={handleChange}
                    // options={workflowOptions}
                    success={formData.dependsOnStepIdStatus === "success"}
                    error={formData.dependsOnStepIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Depends On Type*
                    </MaterialTypography>
                    <MaterialSelect
                    name="dependencyTypeId"
                    value={formData.dependencyTypeId}
                    onChange={handleChange}
                    // options={workflowOptions}
                    success={formData.dependencyTypeIdStatus === "success"}
                    error={formData.dependencyTypeIdStatus === "error"}
                    isDisabled={pageMode === "view"}
                    />
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Condition Expression*
                    </MaterialTypography>
                    <MaterialInput
                        name="conditionExpression"
                        placeholder={`eg. status === \"approved\"`}
                        value={formData.conditionExpression}
                        onChange={handleChange}
                        success={formData.conditionExpressionStatus === "success"}
                        error={formData.conditionExpressionStatus === "error"}
                        disabled={pageMode === "view"}
                    />
                    {formData.conditionExpressionStatus === "error" && (
                        <FormControl error>
                            <FormHelperText>
                                Condition Expression should be a minimum 1 character & maximum 150 characters long.
                            </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>
                <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                        Description
                    </MaterialTypography>
                    <MaterialInput
                        name="description"
                        placeholder="eg. Description of the Workflow Step Dependency"
                        value={formData.description}
                        onChange={handleChange}
                        success={formData.descriptionStatus === "success"}
                        error={formData.descriptionStatus === "error"}
                        disabled={pageMode === "view"}
                        multiline
                        rows={3}
                    />
                    {formData.descriptionStatus === "error" && (
                        <FormControl error>
                            <FormHelperText>
                                Description should be a minimum 1 character & maximum 150 characters long.
                            </FormHelperText>
                        </FormControl>
                    )}
                </Grid2>
                <Grid2 size={{lg:2, md:2, sm: 12, xs: 12 }}>
                    <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold">
                        Actve
                    </MaterialTypography>
                    <FormControlLabel
                    control={
                        <Switch
                            checked={formData.isActive}
                            disabled={pageMode === "view"}
                            onChange={(e) =>
                                handleChange({
                                    target: {
                                        name: "isActive",
                                        value: e.target.checked,
                                    },
                                })
                            }
                            color="primary"
                        />
                    }
                    label={
                        <MaterialTypography variant="caption" fontWeight="bold">
                            {formData?.isActive ? "Yes" : "No"}
                        </MaterialTypography>
                    }
                    sx={{ marginLeft: 0 }}
                    />
                </Grid2>
            </Grid2>
        </CardContent>
        <MaterialBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        >
            {pageMode !== "view" && (
            <>
                <MaterialButton
                sx={{ m: 2 }}
                variant="outlined"
                color="dark"
                onClick={() => navigate("/operation/workflow-step-dependency")}
                >
                Cancel
                </MaterialButton>
                <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmitWorkflowStepDependency}
                >
                {pageMode === "edit" ? "Update" : "Submit"}
                </MaterialButton>
            </>
            )}
        </MaterialBox>
    </DashboardLayout>
  )
}

export default WorkflowStepDependencyForm